export default "__VITE_ASSET__786e7bf8__"